import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dialog, Listbox, Menu, Transition } from "@headlessui/react";

// file import 
import Toast from "../assetLibComponents/shared/Toast";

// library
import { DebounceInput } from "react-debounce-input";

// api action
import { createCannedResponse, fetchCannedListing, removeCannedResponse } from "../../redux/actions/liveChatActions";

// css file
import "../chatAiComponents/ChatAii.css"
import "../liveChat/livechat.css"

// icons 
import { Pencil, X, ChatSquareText, PlusCircle, Search } from 'react-bootstrap-icons';

// left menu data
const navigation = [
    { name: 'Canned Responses', href: '/livechat/setting/canned', icon: ChatSquareText, current: "canned" },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function ChatSetting(props) {
    // dispatch and navigate 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    // authtoken 
    const authToken = props.authToken;
    
    // query and params in url 
    
    // label data
    // const [cannedData, serCannedData] = useState([]);
    const [globalError, setGlobalError] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [cannedId, setCannedId] = useState(null);
    const [shortCode, setShortCode] = useState("");
    const [cannedMessage, setCannedMessage] = useState("");
    
    // popup open close flag 
    const [open, setOpen] = useState(false);
    
    const num_id = useSelector((state) => state.assetLibrary?.userData);
    
    // inbox listing
    const live_chat_listing = useSelector(
        (state) => state.livechat.live_chat_listing?.data
    );
    
    // label list 
    const canned_list = useSelector(
        (state) => state.livechat.canned_listing
    );
    
    // lead id for lead detail 
    const lead_id_store = useSelector(
        (state) => state.livechat.live_bot_listing?.lead_id
    );
    const user_detail_left = useSelector(
        (state) => state.crmLeads.userActivityDetails?.data?.lead_response
    );
    const user_detail = useSelector(
        (state) => state.crmLeads.userActivityDetails?.data?.response
    );
    
    // token 
    const prospect_token = useSelector(
        (state) => state.livechat.live_bot_listing?.prospect_token
    );
    
    // remove search data 
    const handleRemoveSearch = (e) => {
        setSearchValue("");
        dispatch(fetchCannedListing(authToken , 'self', ''));
    };
    
    // add search data 
    const handleSearch = (e) => {
        setSearchValue(e.target.value);
        dispatch(fetchCannedListing(authToken , 'self', e.target.value));
    };
    
    useEffect(() => {
      dispatch(fetchCannedListing(authToken , 'self', null));
    }, [])   
    
    return (
        <>
            <div className="flex w-[97%] max-xl:w-[96%]">
                <div className="w-full max-xl:w-full h-full">
                    <div className="h-full w-full flex">
                        {/* Activity feed */}
                        
                        <aside className="bg-white border-l border-r border-gray-200 h-full w-[13%]">
                            <ul className="w-full mb-3 pt-2">
                                {navigation?.map((item,index) => (
                                    <li key={item.name} className='cursor-pointer'>
                                        <span
                                        className={classNames(
                                            window?.location?.pathname?.includes(item.current)
                                            ? 'bg-gray-50 text-[var(--brand-primary)]'
                                            : 'text-[var(--brand-secondary)] hover:text-[var(--brand-primary)] hover:bg-gray-50',
                                            'group flex items-center gap-x-2 max-xl:gap-x-1 rounded-md p-2 text-sm max-xl:text-xs leading-6 font-semibold'
                                        )}
                                        onClick={() => {
                                            navigate(item.href);
                                        }}
                                        >
                                        <item.icon
                                            className={classNames(
                                                window?.location?.pathname?.includes(item.current) ? 'text-[var(--brand-primary)]' : 'text-gray-400 group-hover:text-[var(--brand-primary)]',
                                            'h-5 w-5 max-xl:h-4 max-xl:w-4 shrink-0'
                                            )}
                                            aria-hidden="true"
                                        />
                                        {item.name}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </aside>
                        
                        <aside className="bg-gray-50 h-full w-[87%]">
                            <header className="flex items-center gap-3 justify-between border-b border-white/5 px-4 py-3">
                                <div className="flex justify-between mb-2 border-b w-full border-gray-200 pb-4">
                                    <div className="relative rounded-md shadow-sm my-auto w-1/3">
                                        <DebounceInput
                                            value={searchValue}
                                            className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Search canned response"
                                            minLength={3}
                                            debounceTimeout={500}
                                            onChange={handleSearch}
                                        />
                                        <div className="absolute z-[9] cursor-pointer right-[3%] top-1/4">
                                        {searchValue && searchValue !== "" ? (
                                            <X onClick={handleRemoveSearch} className="h-4 w-4 text-gray-400 pointer" />
                                            ) : (
                                            <Search className="h-4 w-4 text-gray-400 cursor-pointer" />
                                            )}
                                        </div>
                                    </div> 
                                    <button
                                        onClick={()=>{setOpen(true)}}
                                        type="button"
                                        className="inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                    >
                                    <PlusCircle className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                        Add Canned Response
                                    </button>     
                                </div>
                            </header>
                            <div className="flex"> 
                                <div className="conversations-list flex-1 w-1/2">
                                    <div className="flex mx-4 border-b mb-4 pb-2 border-gray-200">
                                        <div className="w-[80%] flex ml-3">
                                            <p className="w-[30%]">Short Code</p>
                                            <p className="w-[70%]">Content</p>
                                        </div>
                                        <div className="w-[20%] text-right mr-4">Actions</div>
                                    </div>
                                    <ul className="w-full overflow-y-auto listing h-[50vh] px-3">
                                        {canned_list?.length > 0 && canned_list?.map((item) => (
                                            <li
                                                key={item?.cr_id}
                                                className={`col-span-12 cursor-pointer divide-y mb-3 hover:bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)] bg-white divide-gray-200 hover:rounded-none rounded-lg shadow`}
                                                // onClick={() => {
                                                //     handleParamChange(item?.inbox_id, item.conversation_id);
                                                // }}
                                            >
                                                <div className="relative w-full items-center justify-between p-4">
                                                    <div className="flex items-center gap-4">
                                                        <div className="w-[80%] flex">
                                                            <h3 className="text-sm w-[30%] truncate font-medium text-gray-900">
                                                                {item.short_code}
                                                            </h3>
                                                            <h3 className="truncate w-[70%] text-sm font-medium text-gray-900">
                                                                {item.message}
                                                            </h3>
                                                        </div>
                                                        <div className="flex items-center justify-end gap-2 w-[20%]">
                                                            <span
                                                                onClick={() => {
                                                                    setShortCode(item.short_code);
                                                                    setCannedMessage(item.message);
                                                                    setCannedId(item.cr_id);
                                                                    setOpen(true);
                                                                }}
                                                                className="border hover:text-[var(--brand-primary)] hover:border-[var(--brand-primary)] border-[var(--brand-primary)] px-1.5 py-1 rounded-md border-solid cursor-pointer "
                                                            >
                                                                <Pencil className="cursor-pointer text-[var(--brand-primary)] text-[12px]" />
                                                            </span>
                                                            <span
                                                                onClick={()=>{dispatch(removeCannedResponse(authToken, item.cr_id))}}
                                                                className="flex border hover:text-[var(--brand-primary)] border-red-700 px-1.5 py-1 rounded-md border-solid cursor-pointer "
                                                            >
                                                                <X className="cursor-pointer text-red-800  text-[12px]" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="w-1/2 px-20">
                                    <div>
                                        <span>
                                            <p className="text-xl text-gray-600">
                                                <b>Canned Responses</b>
                                            </p>
                                            <br/><p> Canned Responses are pre-written reply templates that help you quickly respond to a conversation. To insert a canned response during a chat, agents can type a short code preceded by a '/' character.</p>
                                            <br/><p> You can manage your canned responses from this page or create new ones using the "Add canned response" button.</p>
                                            {/* <br/><p>Open the <a href="#" className="text-[var(--brand-primary)]" target="_blank">Canned Responses handbook</a> in another tab for a helping hand.</p>
                                            <br/><p>Also, check out the all-new <a href="#" className="text-[var(--brand-primary)]" target="_blank">Canned Responses Library</a>.</p> */}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
            
            
            {/* add canned popup */}
            
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10"
                    onClose={() => {
                        setOpen(false);
                        setTimeout(() => {
                            setCannedId(null);
                        }, 1000);
                    }}
                >
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
                            <div>
                                <p className="flex text-lg leading-6 font-medium">{cannedId === null ? "Add":"Update"} canned response</p>    
                                <p className="flex border-b pb-2 border-gray-200 mb-2 text-xs">Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.</p>                                        
                                {globalError === true && <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
                                    Please fill all the required fields
                                </span>} 
                                <div className="mt-2">
                                    <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                        Short code
                                    </label>
                                    <div>
                                        <input
                                            type="text"
                                            name="code"
                                            id="code"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Please enter a short code"
                                            value={shortCode}
                                            onChange={(e)=>{setShortCode(e.target.value)}}
                                        />
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                                        Message
                                    </label>
                                    <div>
                                        <textarea
                                            type="text"
                                            rows="8"        
                                            name="message"
                                            id="message"
                                            className="block w-full rounded-md resize-none border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Please write the message you want to save as a template to use later."
                                            value={cannedMessage}
                                            onChange={(e)=>{setGlobalError(false); setCannedMessage(e.target.value)}}
                                        />
                                    </div>
                                </div>
                                        
                                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                                        onClick={() => {
                                            if (shortCode != "" && cannedMessage != "") {
                                                setGlobalError(false);
                                                dispatch(createCannedResponse(authToken, shortCode, cannedMessage, cannedId));
                                                setShortCode("");
                                                setCannedMessage("");
                                                setTimeout(() => {
                                                    setCannedId(null);
                                                }, 1000);
                                                setOpen(false)
                                            } else {
                                                setGlobalError(true);
                                            }        
                                        }}
                                    >
                                        {cannedId === null ? "Create":"Update"}
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={() => {
                                            setOpen(false);
                                            setShortCode("");
                                            setCannedMessage("");
                                            setTimeout(() => {
                                                setCannedId(null);
                                            }, 1000);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );    
}
